import * as constants from '@/common/constants';
import { getGlobalConf } from '@/utils/grocer';
const ROUTER_BASE_PATH = getGlobalConf().routerBasePath;

export default {
    methods: {
        navigateTo (routePath) {
            let path = `${ROUTER_BASE_PATH}${routePath}`;
            this.$router.push(path);
        },
        navigateNameTo (routePath, routerName, param) {
            let path = `${ROUTER_BASE_PATH}${routePath}`;
            this.$router.push({ name: routerName, path: path, query: param });
        },
        navLogin  () {
            window.location.href = ROUTER_BASE_PATH;
        },
        navForgetPwd  () {
            this.navigateTo(constants.ROUTE_LOGIN_FORGET_PWD);
        },
        navRegisteFirst  () {
            this.navigateTo(constants.ROUTE_REGISTE_FIRST);
        },
        navRegisteSecond  (userId) {
            this.navigateTo(constants.ROUTE_REGISTE_SECOND.replace(':userId', userId));
        },
        navIndex () {
            this.navigateTo(constants.ROUTE_MAIN_INDEX);
        },
        navFormList () {
            this.navigateTo(constants.ROUTE_FORM_LIST);
        },
        navFormAdd () {
            this.navigateTo(constants.ROUTE_FORM_ADD);
        },
        navFormDetail (formId) {
            this.navigateTo(constants.ROUTE_FORM_DETAIL.replace(':formId', formId));
        },
        navFormCreate (formId) {
            this.navigateTo(constants.ROUTE_FORM_CREATE.replace(':formId', formId));
        },
        navModelAdd (appId, appName, modelType) {
            this.navigateTo(constants.ROUTE_MODEL_ADD.replace(':appId', appId).replace(':appName', appName).replace(':modelType', modelType));
        },
        navModelDetail (formId) {
            this.navigateTo(constants.ROUTE_MODEL_DETAIL.replace(':formId', formId));
        },
        navCronjobAdd () {
            this.navigateTo(constants.ROUTE_CRONJOB_DETAIL);
        },
        navCronjobDetail (jobId) {
            this.navigateTo(constants.ROUTE_CRONJOB_DETAIL.replace(':jobId', jobId));
        },
        navCronjobList () {
            this.navigateTo(constants.ROUTE_CRONJOB_LIST);
        },
        navModelList () {
            this.navigateTo(constants.ROUTE_MODEL_LIST);
        },
        navModelCreate (formId) {
            this.navigateTo(constants.ROUTE_MODEL_CREATE.replace(':formId', formId));
        },
        navWorkflowEditor (processDefinitionId, processServiceId, deploymentId) {
            this.navigateTo(constants.ROUTE_WORKFLOW_EDITOR.replace(':processDefinitionId', processDefinitionId).replace(':processServiceId', processServiceId).replace(':deploymentId', deploymentId || '-'));
        },
        navWorkflowView (processDefinitionId) {
            this.navigateTo(constants.ROUTE_WORKFLOW_VIEWDETAIL.replace(':processDefinitionId', processDefinitionId));
        },
        navWorkflowHistoryView (processDefinitionId, pModelId) {
            this.navigateTo(constants.ROUTE_WORKFLOW_VIEWHISTORYDETAIL.replace(':processDefinitionId', processDefinitionId).replace(':pModelId', pModelId));
        },
        navWorkflowDesign (processId) {
            this.navigateTo(constants.ROUTE_WORKFLOW_DESIGN.replace(':processId', processId));
        },
        navUserList () {
            this.navigateTo(constants.ROUTE_USER_LIST);
        },
        navUserAdd () {
            this.navigateTo(constants.ROUTE_USER_ADD);
        },
        navUserDetail (userId) {
            this.navigateTo(constants.ROUTE_USER_DETAIL.replace(':userId', userId));
        },
        navEmployeeAdd () {
            this.navigateTo(constants.ROUTE_SYSTEM_EMPLOYEE_ADD);
        },
        navEmployeeList () {
            this.navigateTo(constants.ROUTE_EMPLOYEE_LIST);
        },
        navCompanyAdd () {
            this.navigateTo(constants.ROUTE_SYSTEM_COMPANY_ADD);
        },
        navDepartmentAdd (pId, pName) {
            this.navigateTo(constants.ROUTE_SYSTEM_DEPARTMENT_ADD.replace(':pId', pId).replace(':pName', pName));
        },
        navDepartmentList () {
            this.navigateTo(constants.ROUTE_SYSTEM_DEPARTMENT_LIST);
        },
        navPositionAdd (pId, pName) {
            this.navigateTo(constants.ROUTE_SYSTEM_POSITION_ADD.replace(':pId', pId).replace(':pName', pName));
        },
        navPositionList () {
            this.navigateTo(constants.ROUTE_SYSTEM_POSITION_LIST);
        },
        navResourceAdd (pId, pName) {
            this.navigateTo(constants.ROUTE_SYSTEM_RESOURCE_ADD.replace(':pId', pId).replace(':pName', pName));
        },
        navResourceList () {
            this.navigateTo(constants.ROUTE_SYSTEM_RESOURCE_LIST);
        },
        navRoleAdd () {
            this.navigateTo(constants.ROUTE_SYSTEM_ROLE_ADD);
        },
        navRoleList () {
            this.navigateTo(constants.ROUTE_SYSTEM_ROLE_LIST);
        },
        navMyTask () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_TASK);
        },
        /** 跳转新版我的任务页面--我负责的 */
        navMyTaskMyAssignee () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_TASK_MY_ASSIGNEE);
        },
        /** 跳转新版我的任务页面--我参与的 */
        navMyTaskMyTaskParticipant () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_TASK_MY_PARTICIPANT);
        },
        navMyProcess () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_PROCESS);
        },
        /** 跳转新版我的流程页面-我发起的 */
        navMyProcessmyProcessStartedBy () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_PROCESS_STARTED_BY);
        },
        /** 跳转新版我的流程页面-我参与的 */
        navMyProcessMyProcessParticipant () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_PROCESS_PARTICIPANT);
        },
        navMyProcessTemplate () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_PROCESS_TEMPLATE);
        },
        navMyApproval () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_APPROVAL);
        },
        /** 跳转新版审批流模板 */
        navMyApprovalTemplateForApply () {
            this.navigateTo(constants.ROUTE_MY_APPROVAL_TEMPLATE_FOR_APPLY);
        },
        /** 跳转新版审批流模板 */
        navMyApprovalApplied () {
            this.navigateTo(constants.ROUTE_MY_APPROVAL_APPLIED);
        },
        /** 跳转新版我审批的 */
        navMyApprovalApprove () {
            this.navigateTo(constants.ROUTE_MY_APPROVAL_APPROVE);
        },
        navMyMessage () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_MESSAGE);
        },
        navNavProcessState () {
            this.navigateTo(constants.ROUTE_OPERATION_PROCESSSTATE);
        },
        navNavProcessMonitor () {
            this.navigateTo(constants.ROUTE_OPERATION_PROCESSMONITOR);
        },
        navNavProcessTimeGantt () {
            this.navigateTo(constants.ROUTE_OPERATION_PROCESSTIMEGANTT);
        },
        navUserRealtimeState () {
            this.navigateTo(constants.ROUTE_OPERATION_USERREALTIMESTATE);
        },
        navClosedLoop () {
            this.navigateTo(constants.ROUTE_OPERATION_CLOSEDLOOP);
        },
        navApprovalState () {
            this.navigateTo(constants.ROUTE_OPERATION_APPROVALSTATE);
        },
        navApprovalTimeRatio () {
            this.navigateTo(constants.ROUTE_OPERATION_APPROVALTIMERATIO);
        },
        navMyWorkState () {
            this.navigateTo(constants.ROUTE_OPERATION_USERDETAILSTATE);
        },
        navMyBusiness (appId, modelId) {
            this.navigateTo(constants.ROUTE_BUSINESS_MODELLIST.replace(':appId', appId).replace(':modelId', modelId));
        },
        navMyApplication () {
            this.navigateTo(constants.ROUTE_APPLICAION_MODELLIST);
        },
        navCreateApplication () {
            this.navigateTo(constants.ROUTE_APPLICAION_CREATE);
        },
        navConfigApplication (appId, appName, modelId) {
            this.navigateTo(constants.ROUTE_APPLICAION_CONFIG.replace(':appId', appId).replace(':appName', appName).replace(':modelId', modelId));
        },
        navUpdPwd () {
            this.navigateTo(constants.ROUTE_MYSETTING_UPDPWD);
        },
        navUpdFirstPage () {
            this.navigateTo(constants.ROUTE_MYSETTING_UPDFIRSTPAGE);
        },
        navMessage (messageId) {
            this.navigateTo(constants.ROUTE_MESSAGE.replace(':messageId', messageId));
        },
        navBaseInfoSetting () {
            this.navigateTo(constants.ROUTE_MYSETTING_BASEINFOSETTING);
        },
        navMessageTemplateAdd () {
            this.navigateTo(constants.ROUTE_CUSTOMER_MESSAGE_TEMPLATE_ADD);
        },
        navMyWarnMessage () {
            this.navigateTo(constants.ROUTE_PROCESS_MY_WARN_MESSAGE);
        },
        navAppStore () {
            this.navigateTo(constants.ROUTE_APPSTORE_LIST);
        },
        navAppStoreAppView (appId, flag) {
            this.navigateTo(constants.ROUTE_APPSTORE_APP_VIEW.replace(':appId', appId).replace(':flag', flag));
        },
        navAppModelView (formId, appId) {
            this.navigateTo(constants.ROUTE_APPSTORE_MODEL_VIEW.replace(':formId', formId).replace(':appId', appId));
        },
        navAppComponentsView (appId) {
            this.navigateTo(constants.ROUTE_APPSTORE_COMPONENTS_VIEW.replace(':appId', appId));
        },
        navAppModelDataView (appId) {
            this.navigateTo(constants.ROUTE_APPSTORE_APP_DATA_VIEW.replace(':appId', appId));
        },
        navSysHelp () {
            this.navigateTo(constants.ROUTE_SYSTEM_HELP);
        },
        navArchiveNav () {
            this.navigateTo(constants.ROUTE_DOCUMENT_ARCHIVE_NAV);
        },
        navDocArchiveView1 () {
            this.navigateTo(constants.ROUTE_DOCUMENT_ARCHIVE_VIEW1);
        },
        navDocArchiveView2 () {
            this.navigateTo(constants.ROUTE_DOCUMENT_ARCHIVE_VIEW2);
        },
        navResourceAuthNav () {
            this.navigateTo(constants.ROUTE_RESOURCE_AUTH_NAV);
        },
        navSpecialResAuth () {
            this.navigateTo(constants.ROUTE_SPECIAL_RESOURCE_AUTH);
        },
        navRoleResourceAuth () {
            this.navigateTo(constants.ROUTE_ROLE_RESOURCE_AUTH);
        },
        navAppIntroView (appId, appName, appIconPath) {
            this.navigateTo(constants.ROUTE_APPSTORE_APP_INTRO_VIEW.replace(':appId', appId).replace(':appName', appName));
        },
        navProcessFiles () {
            this.navigateTo(constants.ROUTE_DOCUMENT_PROCESS_FILE);
        },
        navNotice () {
            this.navigateTo(constants.ROUTE_APPLICAION_NOTICELIST);
        },
        navNoticeEdit () {
            this.navigateTo(constants.ROUTE_APPLICAION_NOTICEEDIT);
        },
        navTimeConfigGantt (processInstanceId) {
            this.navigateTo(constants.ROUTE_OPERATION_PROCESSTIMEGANTT_PLANTIME.replace(':processInstanceId', processInstanceId));
        },
        // 新版界面
        navNewIndex () { // 首页
            this.navigateTo(constants.ROUTE_MAIN_NEW_INDEX);
        },
        navBusinessSystem () { // 应用中心
            this.navigateTo(constants.ROUTE_BUSINESS_SYSTEM);
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/mixins-nav.js